import { render, staticRenderFns } from "./lp-lover.vue?vue&type=template&id=4babdeb0&scoped=true"
import script from "./lp-lover.vue?vue&type=script&lang=js"
export * from "./lp-lover.vue?vue&type=script&lang=js"
import style0 from "./lp-lover.vue?vue&type=style&index=0&id=4babdeb0&prod&scoped=true&lang=css"
import style1 from "./lp-lover.vue?vue&type=style&index=1&id=4babdeb0&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4babdeb0",
  null
  
)

export default component.exports